var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSustainability(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.237,
    height: 17.65,
    viewBox: "0 0 13.237 17.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_2",
    "data-name": "Union 2",
    d: "M4.243,17.65a1.529,1.529,0,0,1-1.527-1.528v-.339h7.807v.339A1.529,1.529,0,0,1,8.995,17.65ZM2.715,14.765v-.679h7.807v.679Zm4.413-1.7V9.979a3.909,3.909,0,0,0,3.394-3.87V5.431a.51.51,0,0,0-.509-.509A3.9,3.9,0,0,0,6.619,6.9,3.9,3.9,0,0,0,3.225,4.921a.51.51,0,0,0-.509.509v.679a3.909,3.909,0,0,0,3.394,3.87v3.088H2.715v-1.1a6.619,6.619,0,1,1,7.807,0v1.1Zm0-4.243A2.89,2.89,0,0,1,9.5,5.985v.124A2.891,2.891,0,0,1,7.128,8.95ZM3.734,6.109V5.985A2.89,2.89,0,0,1,6.109,8.825V8.95A2.89,2.89,0,0,1,3.734,6.109Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSustainability);
export default __webpack_public_path__ + "static/media/sustainability.5c1da73ba763ff02c6a7d74b88878f28.svg";
export { ForwardRef as ReactComponent };